var $ = require('jquery');

$(function () {
  var $trigger = $('.js-HeaderNavChange__trigger');
  var $view    = $('.js-View');
  $trigger.on('click', function(){
    if($(this).hasClass('is-Active')) {
      $(this).stop().removeClass('is-Active');
      $view.stop().removeClass('is-View');

    } else {
      $(this).stop().addClass('is-Active');
      $view.stop().addClass('is-View');
    }
  });
});

$(function(){
  var $trigger = $('.js-SubNav__trigger');
  var $view = $('.js-SubNav__view');
  $trigger.on('click', function(){
    $trigger.removeClass('is-Active');
    $view.stop().slideUp();
    $(this).addClass('is-Active');
    $(this).next($view).stop().slideDown();
  });
});
